// $(document).ready(function() {
//   jQuery('.multiple-item-add-to-cart-ajax').click(function(e){
  


// });


  
  
  $(document).ready(function() {
    function collectSelectedInput(){
        var data = []
        jQuery('.multiple-checkbox').each(function(){
            current = jQuery(this).find('input:checked');
            if( current.val()){
                data.push({
                        id: current.val(),
                        price: current.data('price'),
                  		quantity: 1,
                    });
            }
        })
        return data;
    }

  var radioState;
  
  
    jQuery('.multiple-checkbox input').click(function(){
      
      if(radioState === this){
        if(this.checked = false){
        	this.checked = true;
        }else{
        	this.checked = false;
        }
  	
        radioState = null;
        this.blur();
      }else{
        radioState = this;
      }
      
//         if( $(this).is(':checked')){
//             $(this).prop('checked',false);
//           console.log(jQuery(this).is(':checked'));
//         }
        data = collectSelectedInput();
        var price = 0;
        data.forEach(function(item){
            price += item.price;
        })

        //print data and price 
        $('.product__selected-count').text(data.length);
        $('.product__state-price.product__price').text(theme.Currency.formatMoney(price, theme.settings.moneyFormat));

        if( data.length > 0){
            $('.multiple-item-add-to-cart-ajax').removeAttr('disabled');
        }else{
            $('.multiple-item-add-to-cart-ajax').attr('disabled', 'true');
        }
    });
    jQuery('.multiple-checkbox input').trigger('change');
    

    $('.multiple-item-add-to-cart-ajax').click(function(e){
      data = collectSelectedInput();
      
     
//       alldata = [];
      
//        fetch('/cart.js')
//   .then((resp) => resp.json())
//      .then((res) => {
//          debugger;
     	
//        alldata = res;
//          console.log(alldata);
         
         
//      });
      
      $.ajax({
        type: "GET",
        url: "/cart.js",
        dataType: 'json',
        success: function(res) {
            console.log(res);
          if(res.item_count>0){
            
//             var newArr = res.items;
            
            
            data.forEach(function(newData,i){
              debugger;
            
              console.log("NewData",newData.id);
              
              res.items.forEach(function(obj,i){
                
                if(parseInt(newData.id) === parseInt(obj.id)){
                  debugger;
                  
                	var id = obj.id;
                  
                  var quantity = ++obj.quantity;
                  
                  console.log(quantity+1);
                  
//                    data.splice(i,1);
                  
                  console.log(data);
                  
//                   data[i].quantity = ++quantity;
                  
                  data.push({
                        id: obj.id,
                        price: obj.price,
                      quantity: quantity
                      	
                    });
                  
            
                  
                  
//                   data = data.filter(newData => !newArr.includes(newData));
                  
                  
//                   await $.ajax({
//                     method:'POST',
//                     url:'/cart/change.js',
//                     data:{ id:id, quantity:(++quantity) },
//                     dataType: 'json',
//                       success: function(){
                      	
                      
//                       }
//                   })
                  
                  
                  debugger;
                
                }
                
                data.push({
                        id: obj.id,
                        price: obj.price,
                      quantity: obj.quantity
                      	
                    });
              
              })
            
            })
            
            
//             res.items.forEach(function(obj){
//               console.log("OldData",obj.id);
              
            	
//             data.push({
//                         id: obj.id,
//                         price: obj.price
//                     });
              
              
              
//             });
            
            updateCart(data);
          }else{
          updateCart(data);
          }
        }
      })   
      
});
    
    
      
      function updateCart(arr){
      console.log(arr);
        var variants = {}
        arr.forEach(function(item){
            variants[item.id] = item.quantity;
          console.log("variants",variants);
        })
        // $.post('/cart.js', {updates: variants});
        $.ajax({
            type: "POST",
            url: "/cart.js",
            data: {updates: variants},
            success: function(){
//               drawer = new theme.Drawers('CartDrawer', 'cart');
//                 console.log(drawer);
//               drawer.drawer.ariaExpanded = true;
              
              
              
              var cartDrawerButtonSelector = ".cart-link";
				var cartDrawerButton = document.querySelector(cartDrawerButtonSelector);
				cartDrawerButton.click();
              
              
              document.dispatchEvent(new CustomEvent('ajaxProduct:added', {
         	bubbles: true,
              detail: {
                variant: "",
                quantity: 0
              }
          }));
              
              
               arr.forEach(function(item){
        let id = item.id;
      	$('#'+id).prop("checked", false);
                 
      })
               
               
//                $.ajax({
//         type: "GET",
//         url: "/cart.js",
//         dataType: 'json',
//                  success: function(res) {
                 	
                 
//                  }
//                });
               
               
              
              
//               document.dispatchEvent(new CustomEvent('cart:updated', {
//               detail: {
//                 cart: cart
//               }
//             }));
              
              $('.multiple-item-add-to-cart-ajax').attr('disabled', 'true');
              $('.product__selected-count').text(0);
        $('.product__state-price.product__price').text("");
             
            }
        });
      
      }



// Open popup when "Join Our Community" button clicked
  document.addEventListener('click', function(e) {
  const btn = e.target.closest('a[href="#join-our-community"]');
  if (!btn) return;
  e.preventDefault();
  document.cookie = 'newsletter_popup=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;';
  const popup = document.querySelector('[data-section-type="newsletter-popup"]');
  if (!popup) return;

  // Always use theme's modal system — it handles open AND close properly
  const modal = new theme.Modals(popup.id, 'newsletter-popup');
  modal.open();
});

document.addEventListener('modalClose', function(e) {
  // Only clean up for newsletter popup specifically
  const popup = document.querySelector('[data-section-type="newsletter-popup"]');
  if (!popup || popup.classList.contains('modal--is-active')) return;
  document.body.classList.remove('js-modal-open');
  document.body.classList.remove('modal--is-active');
});
      
});